import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '../../services/data.service';
import { ResponseType } from 'src/app/features/question/question.component';

interface DiffObject {
  total_questions: number
  answered_questions: number
  maximum_score: number
  score: number
  score_percentage: number
  attempted_percentage: number
  difficulty_count: DifficultyCount
  badge: string
  completed_dfficulty: CompletedDfficulty
}

interface DifficultyCount {
  all: number
  easy: number
  medium: number
  hard: number
}

interface CompletedDfficulty {
  easy: boolean
  medium: boolean
  hard: boolean
}

interface Data {
  easy_status: boolean;
  hard_status: boolean;
  id: string
  category: boolean
  same_route?:boolean
}

@Component({
  selector: 'app-difficulty-level',
  templateUrl: './difficulty-level.component.html',
  styleUrls: ['./difficulty-level.component.scss']
})
export class DifficultyLevelComponent{
  difficultyObject:DiffObject = null;
  same_route = false;
  easy_status = false ;
  hard_status = false ;

  constructor(public dialogRef: MatDialogRef<DifficultyLevelComponent>,
    private dataService:DataService,
    @Inject(MAT_DIALOG_DATA) public data : Data) {

      this.easy_status  = this.data.easy_status
      this.hard_status  = this.data.hard_status
      this.same_route = this.data?.same_route
        this.checkLevel(data)
  }
  checkLevel(data:Data){
    let choice = data.category == true;
    let params = {
      sdg:'',
      difficulty:'',
      topic:'',
      category: choice ? data.id : '',
      country: !choice ? data.id : ''
    }
    this.dataService.getQuestionStatus(params).subscribe({
      next:(res:ResponseType<DiffObject>) =>{
        this.easy_status = res.data.completed_dfficulty.easy
        this.hard_status = res.data.completed_dfficulty.hard
      },
      error:(err) =>{
        console.log(err);
      },
    })
  }

  close(level?:string) {
    this.dialogRef.close(level)
  }

}
